import axios from 'axios'

export type AnalyticsSection = 'overview' | 'pages' | 'users' | 'features' | 'performance' | 'realtime'

export interface AnalyticsFilters {
  from: string
  to: string
  user_guid?: string
  path?: string
  company_guid?: string
}

export interface AnalyticsAccessTarget {
  event_type: 'page_view' | 'feature_use'
  path: string | null
  feature_name?: string
}

export interface AnalyticsAccessDetails {
  summary: {
    accesses: number
    users: number
    sessions: number
    first_access: string | null
    last_access: string | null
  }
  accesses: Array<{
    id: number
    user_guid: string | null
    user_name: string
    user_email: string | null
    company_name: string | null
    occurred_at: string
  }>
  pagination: {page: number; limit: number; total: number; total_pages: number}
}

const cleanParams = (filters: AnalyticsFilters) =>
  Object.entries(filters).reduce<Record<string, string>>((params, [key, value]) => {
    if (value) params[key] = value
    return params
  }, {})

export const getAnalyticsSection = async (section: AnalyticsSection, filters: AnalyticsFilters) => {
  const response = await axios.get(`/analytics/${section}`, {params: cleanParams(filters)})
  return response.data
}

export const getAnalyticsFilters = async (companyGuid?: string) => {
  const response = await axios.get('/analytics/filters', {
    params: companyGuid ? {company_guid: companyGuid} : undefined,
  })
  return response.data
}

export const getAnalyticsAccessDetails = async (
  filters: AnalyticsFilters,
  target: AnalyticsAccessTarget,
  page = 1,
  signal?: AbortSignal
) => {
  const response = await axios.get<{success: boolean; data: AnalyticsAccessDetails}>(
    '/analytics/access-details',
    {
      params: {
        ...cleanParams(filters),
        ...target,
        path: target.path || undefined,
        path_missing: target.path === null ? 'true' : undefined,
        page,
      },
      signal,
    }
  )
  if (!response.data.success) throw new Error('Não foi possível consultar os acessos.')
  return response.data.data
}
